<div class="airport-icons">
  <!-- Closed/Abandoned -->
  <app-badge *ngIf="closed" [icon]="'airports:closed'" [label]="closedLabel" [cls]="'closed'" [compact]="compact"></app-badge>

  <!-- Ownership category (civil, private, or military). These badges are mutually exclusive. -->
  <app-badge *ngIf="civil && !compact" [label]="'Civil'" [cls]="'civil'" [compact]="compact"></app-badge>
  <app-badge *ngIf="privateOwn && !compact" [label]="'Privately-owned'" [cls]="'private-own'" [compact]="compact"></app-badge>
  <app-badge *ngIf="military" [icon]="'airports:military'" [label]="militaryLabel" [cls]="'military'" [compact]="compact"></app-badge>

  <!-- Airport type. These badges should be mutually exclusive. -->
  <app-badge *ngIf="heliport" [icon]="'airports:heliport'" [label]="'Heliport'" [cls]="'heliport'" [compact]="compact"></app-badge>
  <app-badge *ngIf="seaport" [icon]="'airports:seaport'" [label]="'Seaplane Base'" [cls]="'seaport'" [compact]="compact"></app-badge>
  <app-badge *ngIf="ultralight" [label]="'Ultralight Park'" [cls]="'ultralight'" [compact]="compact"></app-badge>
  <app-badge *ngIf="gliderport" [label]="'Gliderport'" [cls]="'glider'" [compact]="compact"></app-badge>
  <app-badge *ngIf="balloonport" [label]="'Balloonport'" [cls]="'balloon'" [compact]="compact"></app-badge>

  <!-- Usage type (public or private). These badges are mutually exclusive. -->
  <app-badge *ngIf="privateUse" [icon]="'airports:private'" [label]="'Private Use'" [cls]="'private-use'" [compact]="compact"></app-badge>
  <app-badge *ngIf="publicUse && !compact" [label]="'Public Use'" [cls]="'public'" [compact]="compact"></app-badge>

  <!-- Unpaved (grass strips) -->
  <app-badge *ngIf="unpaved" [icon]="'airports:unpaved'" [label]="'Unpaved'" [cls]="'unpaved'" [compact]="compact"></app-badge>

  <!-- Airport of Entry -->
  <app-badge *ngIf="aoe" [label]="'AOE'" [cls]="'aoe'" [compact]="compact" [matTooltip]="'Airport of Entry'"></app-badge>
</div>
